/* eslint-disable react/display-name */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2026-04-29 15:05:20
 */
import './index.scss'
import React, { useEffect, useState, useRef } from 'react'

import { Layout, Modal, Input, Button } from 'antd'
import PersonStat from './components/personStat/index'
import type { PersonStatRef } from './components/personStat/index'
import PhotoStat from './components/photoStat/index'
import type { PhotoStatRef } from './components/photoStat/index'
import WatermarkStat from './components/watermarkStat/index'
import type { WatermarkStatRef } from './components/watermarkStat/index'
import dayjs from 'dayjs'
import CONFIG from '../../constants/config'
import { useAppSelector, useSensorsRole } from '../../app/hooks'
import sensors from '../../utils/sensors'
import { SyncOutlined } from '@ant-design/icons'

import PageHeader from '@/components/PageHeader'
const { Content } = Layout
const { TextArea } = Input
export default () => {
  const [showModal, setShowModal] = useState(false)
  const [refreshDate, setRefreshDate] = useState('')
  const photoStatRef = useRef<PhotoStatRef>(null)
  const personStatRef = useRef<PersonStatRef>(null)
  const watermarkStatRef = useRef<WatermarkStatRef>(null)
  const [spinDegree, setSpinDegree] = useState(0)
  const [inputValue, setInputValue] = useState('')
  const groupID = useAppSelector((state) => state.group.groupId)
  const role = useSensorsRole()

  useEffect(() => {
    setRefreshDate(dayjs(new Date()).format(CONFIG.photoTimeFormat))
  }, [])
  useEffect(() => {
    /* noop */
  }, [spinDegree])

  const handleOk = () => {
    handleCustomDataBoardReportSA('confirm', {
      content: inputValue
    })
    setShowModal(false)
  }
  const handleCancel = () => {
    handleCustomDataBoardReportSA('cancel')
    setInputValue('')
    setShowModal(false)
  }

  const refreshData = () => {
    setSpinDegree((prev) => prev + 180)
    setRefreshDate(dayjs(new Date()).format(CONFIG.photoTimeFormat))
    photoStatRef.current?.refreshData()
    personStatRef.current?.refreshData()
    watermarkStatRef.current?.refreshData()
  }

  const handleClickReportSA = (
    clickItem: string,
    params: Record<string, unknown> = {}
  ) => {
    console.log('clickItem', clickItem, params)
    sensors.track('web_click_data_statistic', {
      clickItem,
      role,
      groupID,
      ...params
    })
  }
  const handleCustomDataBoardReportSA = (
    actionType: string,
    params: Record<string, unknown> = {}
  ) => {
    console.log('handleCustomDataBoardReportSA', actionType)
    sensors.track(
      'web_get_action_pop_custom_data_board_suggestion_collection',
      {
        actionType,
        ...params,
        role,
        groupID
      }
    )
  }
  return (
    <Layout className="data-statistics">
      <PageHeader
        className="Header"
        ghost={true}
        title={
          <div className="data-statistics-header">
            <h4>数据看板</h4>
            <div className="upload-date">
              更新时间： {refreshDate}
              <SyncOutlined
                className="reload-icon"
                onClick={() => refreshData()}
                style={{
                  marginLeft: '4px',
                  transform: `rotate(${spinDegree}deg)`,
                  transition: 'transform 0.5s ease-in-out'
                }}
              />
            </div>
          </div>
        }
        extra={
          <>
            <div
              className="want-more"
              onClick={() => {
                handleCustomDataBoardReportSA('popShow')
                handleClickReportSA('customizeBoard')
                setShowModal(true)
              }}
            >
              <Button type="primary" ghost>
                自定义看板
              </Button>
            </div>
          </>
        }
      />
      <Content className="data-statistics-content">
        <div className="main-content-container">
          <div className="stat-card">
            <PhotoStat
              ref={photoStatRef}
              handleClickReportSA={handleClickReportSA}
            />
          </div>
          <div className="stat-card">
            <PersonStat
              ref={personStatRef}
              handleClickReportSA={handleClickReportSA}
            />
          </div>
          <div className="stat-card">
            <WatermarkStat
              ref={watermarkStatRef}
              handleClickReportSA={handleClickReportSA}
            />
          </div>
        </div>
      </Content>
      <Modal
        title="你需要查看什么数据看板呢"
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {showModal && (
          <TextArea
            onChange={({ target: { value } }) => {
              setInputValue(value)
            }}
            placeholder="请输入你关注的数据，我们会尽快实现"
            maxLength={100}
            rows={4}
          />
        )}
      </Modal>
    </Layout>
  )
}
